import { useEffect, useState } from "react"

function format(msLeft: number): string {
  const totalSeconds = Math.max(Math.ceil(msLeft / 1000), 0)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60

  return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
}

export default function useCountdown(minutes: number): {
  isExpired: boolean
  timeLeft: string
} {
  const [endTime] = useState(() => Date.now() + minutes * 60 * 1000)
  const [msLeft, setMsLeft] = useState(minutes * 60 * 1000)

  useEffect(() => {
    const interval = setInterval(() => {
      const remaining = endTime - Date.now()

      setMsLeft(remaining)

      if (remaining <= 0) clearInterval(interval)
    }, 250)

    return () => clearInterval(interval)
  }, [endTime])

  return { isExpired: msLeft <= 0, timeLeft: format(msLeft) }
}
